<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="position: relative;overflow: auto;height: 100%;">

    <div class="container">

        <div class="row" style="margin-top:2%;margin-bottom:2%">

            <div class="col-lg-12 text-center" style="font-weight:bold;font-size:18px">

                Transaction Table Details

            </div>

        </div>

        <div class="row" *ngFor="let displayName of displayNames;let i = index" style="margin:1%">

            <div class="col-lg-6" style="font-weight:bold">

                {{displayName}}

                <span> :</span>

            </div>

            <div class="col-lg-6">

                {{displayValues[i]}}

            </div>

        </div>

        <div class="row topRowmargins" style="margin-top:1%">

            <div class="col-lg">

            </div>

            <div class="col-lg text-center">
                
                <button i18n="@@spmsloginbutton" type="button"
                    class="SUCButtons btn blue-gradient btn-primary btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: 0.3rem 1.6rem;font-size: 0.85rem;background: #d71920 !important;width: 70%;float:right" (click)="close()">Cancel</button>

            </div>

            <div class="col-lg">

            </div>

        </div>

    </div>

</div>